//import { FormattedMessage } from "react-intl";

//import RadioGroupItem from "../../../app/generic/form/radioGroupItem";

export const legalEntityName = "Legal",
  physicalName = "Physical";

const Type = ({ onTypeChange, formItemLayout }) => (
  <>
    {/* <RadioGroupItem
    size="large"
    fieldName="type"
    onChange={onTypeChange}
    formItemLayout={formItemLayout}
    options={[
      {
        id: physicalName,
        name: (
          <FormattedMessage
            id="registration.person.physical"
            defaultMessage="Fyzická osoba"
          />
        ),
      },
      {
        id: legalEntityName,
        name: (
          <FormattedMessage
            id="registration.person.legal"
            defaultMessage="Právnická osoba"
          />
        ),
      },
    ]}
  /> */}
  </>
);

export default Type;
